import script from "./TopListEntitiesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopListEntitiesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopListEntitiesPanel.vue?vue&type=style&index=0&id=d867bec2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d867bec2"]])

export default __exports__